<template lang="pug">
  v-navigation-drawer.app-navigation-menu.pa-0(
    :value='isDrawerOpen'
    app
    floating
    width='300'
    :right='$vuetify.rtl'
    @input="val => $emit('update:is-drawer-open', val)"
  )
    //- Navigation Header
    .vertical-nav-header.d-flex.items-center.ps-6.pe-5.pt-5.pb-2
      router-link.d-flex.align-center.text-decoration-none(:to="home")
        //- v-img.app-logo.me-3(
        //-   :src="require('@/assets/images/logos/logo.svg')"
        //-   max-height='30px'
        //-   max-width='30px'
        //-   alt='logo'
        //-   contain eager
        //- )
        v-slide-x-transition
          h2.app-title.text--primary
            app-title

    //- Navigation Items
    v-list.vertical-nav-menu-items(
      expand
      shaped
      dense
    )

      //- Seleção de Sítio
      v-tooltip(bottom)
        template(#activator="{ on, attrs }")
          v-list-item.pr-3.text-no-wrap(
            v-bind="attrs"
            v-on="on"
            :to="$to({ site: 'Home', eref: 'Home.Sitios' })"
            dense
          )
            v-list-item-icon
              v-icon(small) mdi-home-city

            v-list-item-content
              v-list-item-subtitle {{ site }}

        span
          span.text-md.font-weight-medium Sítios
          br
          span.font-weight-light Seleção e sítio.

      //- Seleção de Aplicativo
      v-tooltip(bottom)
        template(#activator="{ on, attrs }")
          v-list-item.pr-3.text-no-wrap(
            v-if="site"
            v-bind="attrs"
            v-on="on"
            :to="$to('Index.Workspace')"
            dense
          )
            v-list-item-icon
              v-icon(small) mdi-apps

            v-list-item-content
              v-list-item-subtitle Aplicativos

        span
          span.text-md.font-weight-medium Aplicativos
          br
          span.font-weight-light Seleção e aplicativo.

      //- Páginas
      v-list-item.pr-1.text-no-wrap(
        v-for="(menu, index) in menus"
        dense
        :key="`menu-${index}`"
        :to="$to(menu.eref)"
        :input-value="isOpen(menu)"
      )
        v-list-item-icon
          v-icon.ml-n5.mr-n1(
            v-if="isOpen(menu)"
          )
            | mdi-menu-right

          v-icon(small)
            | {{ menu.icon || 'mdi-link' }}

        v-tooltip(bottom)
          template(#activator="{ on, attrs }")

            v-list-item-content(
              v-bind="attrs"
              v-on="on"
            )
              v-list-item-subtitle {{ menu.title }}

          span
            span.text-md.font-weight-medium {{ menu.title }}
            br
            span.font-weight-light {{ menu.description }}


        template(v-if="isOpen(menu)")
          v-list-item-icon(
            @click.prevent="$close(menu)"
          )
            v-icon(small)
              | mdi-close

  </template>

  <style lang="scss" scoped>
  .app-title {
    font-size: 1.25rem;
    font-weight: 700;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.3px;
  }

  // ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
  .app-logo {
    transition: all 0.18s ease-in-out;
    .v-navigation-drawer--mini-variant & {
      transform: translateX(-4px);
    }
  }

  @include theme(app-navigation-menu) using ($material) {
    background-color: map-deep-get($material, 'background');
  }

  .app-navigation-menu {
    .v-list-item {
      &.vertical-nav-menu-link {
        ::v-deep .v-list-item__icon {
          .v-icon {
            transition: none !important;
          }
        }
      }
    }
  }

  // You can remove below style
  // Upgrade Banner
  .app-navigation-menu {
    .upgrade-banner {
      position: absolute;
      bottom: 13px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  </style>

  <script>
  import { mapState } from 'vuex'
  import { canonicalizeWorkspaceLink } from '@/helpers/canonicalization'
  import { workspaceFor } from '@/helpers/links'
  import { ENTITY } from '@/store/mutation-types'

  import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
  import NavMenuGroup from './components/NavMenuGroup.vue'
  import NavMenuLink from './components/NavMenuLink.vue'
  import AppTitle from "@/components/commons/layout/AppTitle"
  import ActionBarExMenuItem from "@/components/commons/action-bar-ex/ActionBarExMenuItem"

  // eslint-disable-next-line object-curly-newline
  import {
    mdiHomeOutline,
    mdiAlphaTBoxOutline,
    mdiEyeOutline,
    mdiCreditCardOutline,
    mdiTable,
    mdiFileOutline,
    mdiFormSelect,
    mdiAccountCogOutline,
  } from '@mdi/js'

  export default {
    components: {
      NavMenuSectionTitle,
      NavMenuGroup,
      NavMenuLink,
      AppTitle,
      ActionBarExMenuItem,
    },

    props: {
      isDrawerOpen: {
        type: Boolean,
        default: null,
      },
    },

    data: () => ({
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
      },
    }),

    computed: {
      ...mapState('system', [
        'identity'
      ]),

      ...mapState({
        workspace (state) {
          return state[ENTITY][this.workspaceLink.path]
        },
      }),

      hasMenu() {
        return this.domainLinks.length > 0
      },

      workspaceLink () {
        const { site, eref } = this.$route.params
        return canonicalizeWorkspaceLink(this, { site, eref })
      },

      site () {
        return this.$route.params.site
      },

      home () {
        return this.$to({ eref: 'Index.Workspace', site: this.site })
      },

      links () {
        return this.workspace?.links || []
      },

      openPapers () {
        let entities = Object.values(this.$store.state.entity)

        let papers = entities.filter(entity =>
          entity.type === 'Paper' || entity.type === 'Workspace')

        let openPapers = papers.filter(paper =>
          paper.keepOpen === true
            && paper.site === this.workspace?.site
            && workspaceFor(paper.eref) === this.workspace?.eref
            )

        return openPapers
      },

      menus() {
        return [
          ...this.links.map(link => {
            let relatedPaper = this.openPapers.filter(
                  paper => (paper.eref || paper.name) === (link.eref || link.name))[0]
            return relatedPaper || link
          }),
          ...this.openPapers.filter(paper => {
            let linked = this.links.filter(
                  link => (paper.eref || paper.name) === (link.eref || link.name))[0]
            return !linked
          }),
        ]
      },
    },

    methods: {
      minify (state) {
        this.container?.minify(state)
      },

      isOpen (menu) {
        return menu.type === 'Paper' || menu.type === 'Workspace'
      },

      isLocked (menu) {
        return menu.waitingFor && menu.waitingFor.length
      },

      isCurrent (menu) {
        return menu.eref == this.$route.params.eref
      },

      perform(opts) {
        // TODO: FIXME: Substituir pelo novo: @/helpers/actions/performAction()
        const link = opts.link
        const rules = opts.link.rule || []
        const browse = rules.some(rule => rule === 'Browse')
        if (browse) {
          this.$go(link)
        } else {
          this.request = opts
        }
      },
    },
  }
  </script>
